export default __webpack_public_path__ + "firstpassLogo.02edb1e6.png";